export const state = {
  loading: false,
  imageForActions: '',
  imageResult: '',
  imagePrev: '',
  sourceBgImage: '',
};
